import React, { useState, useEffect } from "react";
import Hero from "../components/Hero";
import Projects from "../components/Projects";
import Contact from "../components/Contact";
import Career from "../components/Career";

export default function Home() {

  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowButton(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="space-y-16 md:space-y-24">
      <Hero />
      <section id="about" className="scroll-mt-24">
        <Career />
      </section>
      <section id="work" className="scroll-mt-24">
        <Projects />
      </section>
      <section id="contact" className="scroll-mt-24">
        <Contact />
      </section>

       {showButton && (
        <button
          onClick={scrollToTop}
          title="Go to top"
          className="fixed bottom-6 right-6 sm:right-10 w-10 h-10 bg-sky-500 hover:bg-sky-600 text-white rounded-full flex items-center justify-center shadow-lg transition duration-300 z-50"
          aria-label="Scroll to top"
        >
          ↑
        </button>
      )}

    </div>
  );
}
